import styled from "styled-components";

export const Tr = styled.tr`
  border: 1px solid #e6e6e6;
`;

Tr.displayName = "Tr";

export default Tr;



// WEBPACK FOOTER //
// ./src/legacy-tv-ui/Tr/Tr.js